
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MoqupMatrice extends Vue {

  private headers = [
    {value: "group", text: "Groupe de canons"},
    {value: "checkbox1", text: "PASSE GENERAL"},
    {value: "checkbox2", text: "PASSE GENERAL T"},
    {value: "checkbox3", text: "PASS CLIM"},
  ];
  private items = [
    {
      group: "Canon T046134",
      checkbox1: true,
      checkbox2: true,
      checkbox3: true,
    },
    {
      group: "Canon secours",
      checkbox1: true,
      checkbox2: true,
      checkbox3: false,
    },
  ];
}
